import type { WalletProvider } from '@/extensions/snk/lib/device-utils';
import { resolveAssetUrl } from '@/lib/utils';
import { AppStoreBadge, Typography } from '@/shared-ui';

const DOWNLOAD_QR_CODE_PATH = '/images/download-qr-code.png';

export type DownloadAppProps = {
    appStorePlatform: WalletProvider;
};

export const DownloadApp = ({ appStorePlatform }: DownloadAppProps) => {
    return (
        <div>
            <Typography weight="regular" variant="h4" className="text-secondary mt-0">
                Download our app
            </Typography>
            <img
                src={resolveAssetUrl(DOWNLOAD_QR_CODE_PATH)}
                alt="QR code to download the app"
                className="hidden md:block mt-4 w-[78px] h-auto"
            />
            <AppStoreBadge platform={appStorePlatform} variant="secondary" className="mt-4 w-full h-auto md:hidden" />
        </div>
    );
};
